import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useFetch(address, reload) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const mount = async () => {
      await axios
        .request(address, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async response => {
          const { data: responseData } = await response;
          const { input, data: internalData } = responseData;
          setData(input || internalData || responseData);
          setLoading(false);
        })
        .catch(error => {
          setLoading(true);
          console.error(`FETCH HOOK ERROR: ${error}`);
        });
    };
    // eslint-disable-next-line no-unused-expressions
    address ? mount() : false;
  }, [address, reload]);

  return [data, loading];
}
